import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background-50 px-6 text-center">
      <span className="text-8xl font-bold font-heading text-primary-500 mb-4">404</span>
      <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">Strona nie została znaleziona</h1>
      <p className="text-base text-foreground-600 max-w-[400px] mb-8">
        Przepraszamy, strona której szukasz nie istnieje lub została przeniesiona.
      </p>
      <Link
        to="/"
        className="px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
      >
        Wróć do Strony Głównej
      </Link>
    </div>
  );
}